import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { debounce } from "lodash";
// @mui
import { Container, Typography, Stack, Chip, Switch, FormControlLabel, TextField, Button, InputAdornment } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
// components
import { useSettingsContext } from '../../components/settings';
import CustomPagination from '../../components/custom-pagination';
import Iconify from '../../components/iconify';
import CustomModal from "../../components/custom-modal";
import DiagnosisView from './DiagnosisView';
import CustomGrid from '../../components/custom-grid';

import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getdiagnosis } from '../../APIs/diagnosis';
import {getDiagnosisListColumns} from './DiagnosisColumns'

// ----------------------------------------------------------------------
import { useAuthContext } from '../../auth/useAuthContext';

export default function DiagnosisList() {
    const { themeStretch } = useSettingsContext();
    const axiosPrivate = useAxiosPrivate();
    const { user } = useAuthContext();
    const [includeOnlyActive, setIncludeOnlyActive] = useState(false);
    const [totalDiagnosis, setTotalDiagnosis] = useState(0);
    const [diagnosis, setDiagnosis] = useState([]);    
    const [term, setTerm] = useState();
    const [fullWidth] = useState(true);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(20);
    const [openModal, setOpenModal] = useState(false);
    const [selectedDiagnosis, setSelectedDiagnosis] = useState();
    const [readOnly, setReadOnly] = useState(true);
    
    const getDiagnosis = (currentPage = 1) => {
        const request = { includeOnlyActive,term, size, page: currentPage ?? page }
        setPage(request.page);

        getdiagnosis(axiosPrivate, request, (response) => {
            const { data, total } = response;
            setDiagnosis(data);
            setTotalDiagnosis(total);
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getDiagnosis, [includeOnlyActive,term, size]);    

    const handleChange = (event) => {
        setIncludeOnlyActive(event.target.checked);
    };

    const handleSearch = (event) => {
        setTerm(event.target.value);
    }

    const handlePageChange = (pageIndex) => {
        setPage(pageIndex);
        getDiagnosis(pageIndex);
    }

    const handlePageSizeChange = (pageSize) => {
        setSize(pageSize);
    }

    const onHandleClose = () => {
        setSelectedDiagnosis();
        setReadOnly(true);
        setOpenModal(false);
    }

    const handleRowClick = ({ row }) => {
        setSelectedDiagnosis(row);
        setOpenModal(true);
        setReadOnly(true);
    }

    const onEdit = (id) => {
        const _diagnosis = diagnosis.find(c => c.id === id);
        setSelectedDiagnosis(_diagnosis);
        setReadOnly(false);
        setOpenModal(true);
    }

    const onAdd = () => {
        setReadOnly(false);
        setOpenModal(true);
    }

    const handleUser = () => {
        getDiagnosis(page);
        onHandleClose();
    }

    const debouncedChangeHandler = debounce(handleSearch, 500);

    const columns = getDiagnosisListColumns({ onEdit });

    return (
        <>
            <Helmet>
                <title>Diagnosis | flok</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'}>
                <Stack
                    flexGrow={1}
                    direction="column"
                    justifyContent="flex-start"
                    spacing={{ xs: 0.5, sm: 1.5 }}>
                    <Typography variant="h4" component="h4" paragraph>
                    Floks <Chip label={totalDiagnosis} />
                        <Button style={{ marginLeft: '2%', minWidth: 0 }} variant="outlined" onClick={onAdd}>+</Button>
                    </Typography>
                    <Stack
                        flexGrow={1}
                        direction="row"
                        justifyContent="flex-start"
                        spacing={{ xs: 0.5, sm: 1.5 }}>
                        <TextField
                            hiddenLabel
                            placeholder="Search..."
                            size="small"
                            onChange={debouncedChangeHandler}
                            fullWidth={fullWidth}
                            defaultValue={term}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={includeOnlyActive}
                                    onChange={handleChange}
                                    inputProps={{ 'aria-label': 'controlled' }} />
                            }
                            label="Hide Deleted Diagnosis" />
                    </Stack>
                    <CustomGrid>
                        <DataGrid
                            sx={{
                                '.MuiDataGrid-columnHeaders': {
                                    backgroundColor: 'lightgray'
                                },
                                '.MuiDataGrid-columnSeparator': {
                                    display: 'none',
                                },
                                '&.MuiDataGrid-root': {
                                    border: 'none'
                                },
                                '.MuiDataGrid-row': {
                                    cursor: 'pointer'
                                },
                                '.MuiDataGrid-footerContainer': {
                                    display: 'none'
                                }
                            }}
                            rows={diagnosis}
                            columns={columns}
                            disableColumnMenu
                            disableColumnFilter
                            disableRowSelectionOnClick
                            hideFooterPagination
                            onRowClick={handleRowClick}
                        />
                    </CustomGrid>
                    <CustomPagination pageSize={size} currentPage={page} total={totalDiagnosis} handleChange={handlePageChange} handlePageSizeChange={handlePageSizeChange} />
                    <CustomModal open={openModal} onClose={onHandleClose}>
                        <DiagnosisView onChangeUser={handleUser} item={selectedDiagnosis} onHandleClose={onHandleClose} readOnly={readOnly} />
                    </CustomModal>
                </Stack>
            </Container>
        </>
    );
}

